import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export default function SafesGardTables(props) {
    const { data ,rptParams} = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 16,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#000"
    }

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#3f51b5" ,
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 17,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {t("no")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("barcode_number")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("item")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("balance")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {rptParams.typeCost.name}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("total_cost")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("sale_total")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("total_incoming")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("total_exchange")}
                        </TableCell>
                       
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, i) => (
                        <TableRow key={row.barcode}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 17,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center">{i + 1}</TableCell>
                            <TableCell style={stylRo} align="center">{row.barcode}</TableCell>
                            <TableCell style={stylRo} align="center">{row.Name_Item}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Balance)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.cost)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.sumCost_item)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row?.Sum_sale_price??0)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Income)?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row.Outcome)?.toFixed(2)}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
